import { render, staticRenderFns } from "./AccompanyingEquipment.vue?vue&type=template&id=081a8201&scoped=true"
import script from "./AccompanyingEquipment.vue?vue&type=script&lang=js"
export * from "./AccompanyingEquipment.vue?vue&type=script&lang=js"
import style0 from "./AccompanyingEquipment.vue?vue&type=style&index=0&id=081a8201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a8201",
  null
  
)

export default component.exports